const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de historial de recepciones',
  PAGE_DESCRIPTION:
    'En este apartado puede visualizar todas las recepciones que alguna vez se hicieron en este almacén.'
};

export default HELPER_TEXTS;
